import { MARQUEE_ITEMS } from "@/constants/site";

const Row = ({ hidden }) => (
  <div className="flex items-center gap-12" aria-hidden={hidden || undefined}>
    {MARQUEE_ITEMS.map((item, i) => (
      <span
        key={`${item}-${i}`}
        className={i % 2 === 0 ? "text-white font-bold" : "text-[#38bdf8]"}
      >
        » {item}
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="overflow-hidden bg-[#090f1d] py-4 border-b border-[#203154]"
    data-testid="marquee-strip"
  >
    <div className="mq-track flex items-center gap-12 font-mono text-xs uppercase tracking-widest text-[#9cb4d8]">
      <Row />
      <Row hidden />
    </div>
  </div>
);
